import classNames from 'classnames';
import { FC, useMemo } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { Icon7Days } from 'src/general/Icons/Icon7Days';
import { IconFreeDelivery } from 'src/general/Icons/IconFreeDelivery';
import { IconOpenBonnet } from 'src/general/Icons/IconOpenBonnet';
import { IconWarranty } from 'src/general/Icons/IconWarranty';
import { ReviewSummaryProps } from 'src/hygiene/components/flexible-content/ReviewSummary/ReviewSummary.types';
import { ReviewSummaryLegacy } from 'src/hygiene/components/flexible-content/ReviewSummary/ReviewSummaryLegacy';
import { getMicrocopyBulk } from 'src/stores/microcopyStore';

import styles from './CarmaCoreValue.module.scss';

export const CarmaCoreValue: FC = () => {
  const { examinedExperts, return7Days, warranty, freeDelivery } = getMicrocopyBulk({
    examinedExperts: [MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_1],
    warranty: [MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_2],
    return7Days: [MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_3],
    freeDelivery: [MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_4],
  });

  const reviewProps: ReviewSummaryProps = {
    sectionData: { linksType: 'none' as const, links: null },
    classNameCard: styles.card,
  };

  const content = useMemo(
    () => [
      { Icon: IconOpenBonnet, content: examinedExperts, key: MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_1 },
      { Icon: IconWarranty, content: warranty, key: MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_2 },
      { Icon: Icon7Days, content: return7Days, key: MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_3 },
      { Icon: IconFreeDelivery, content: freeDelivery, key: MICROCOPY.PDP_CARMA_CORE_VALUE_PROPS_TITLE_4 },
    ],
    [examinedExperts, return7Days, warranty, freeDelivery],
  );

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={classNames(styles.contentContainer, styles.containerFull)}>
          {content.map(({ Icon, content, key }) => (
            <div className={styles.content} key={key}>
              <Icon />
              <p className={classNames(styles.valueText, 'c-fw-normal', 'c-fs-body2')}>{content}</p>
            </div>
          ))}
        </div>
        <hr className={styles.separator} />
        <div className={styles.reviewsContainer}>
          <ReviewSummaryLegacy {...reviewProps} />
        </div>
      </div>
    </div>
  );
};
